module.exports = __webpack_public_path__ + "static/media/Amino-AltBold.1bd4380f.ttf";